import { useEffect, useState } from 'react';
import { getBranchReceiptsTotals } from '../services';
import { IBranchReceiptsTotalsData, HookState } from '../types';
import { resolveErrorMessage } from './hookUtils';

/** Totales de recibos sin depositar de todas las cajas (vista agrupadora). */
export function useBranchReceiptsTotals(): HookState<IBranchReceiptsTotalsData> {
	const [state, setState] = useState<HookState<IBranchReceiptsTotalsData>>({
		data: null,
		loading: true,
		error: null,
		cachedAt: null,
	});

	useEffect(() => {
		let cancelled = false;

		getBranchReceiptsTotals()
			.then(({ data, cachedAt }) => {
				if (!cancelled) setState({ data, loading: false, error: null, cachedAt });
			})
			.catch((err) => {
				if (!cancelled) setState({ data: null, loading: false, error: resolveErrorMessage(err), cachedAt: null });
			});

		return () => {
			cancelled = true;
		};
	}, []);

	return state;
}
